import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../sidebar/Sidebar";
import axios from "axios";
import api from "../../api/axios";
import ticket from "../images/ticket_image.png";
import logo from "../images/recipt _ Logo 1.png";
import SyncLoader from "react-spinners/SyncLoader";
import PopUP from "../Popup/PopUP";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

function MyOrder() {
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [, setError] = useState(null);
  const [inputdata, setInputdata] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [lodding, setLodding] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [userdata, setUserdata] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [recieptPopup, setRecieptPopup] = useState(false);
  const [selectedReciept, setSelectedReciept] = useState([]);

  const [expendedRow, setExpendedRow] = useState(null);
  const fetchuserdata = async () => {
    try {
      setLodding(true);
      const res = await api.get("/order");
      const currUser = localStorage.getItem("useremail");
      setCurrentUser(currUser);
      setUserdata(res.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLodding(false);
    }
  };
  useEffect(() => {
    fetchuserdata();
  }, []);
  const filtereddata = Object.values(
    userdata.filter((user) => user.emaiid === currentUser)
  );

  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  //for input change
  const handleChange = (e) => {
    setInputdata(e.target.value);
  };

  //fetch data
  useEffect(() => {
    const fetchPayments = async () => {
      try {
        setLodding(true);
        const response = await api.get("/payments");
        setTimeout(() => {
          setLodding(false);
        }, 2000);
        setPayments(response.data.items || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLodding(false);
      }
    };
    fetchPayments();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    //filter data
    const fdata = filtereddata.filter((user) => {
      return (
        (user.razorpayOrderId?.toString() || "").includes(inputdata) ||
        (user.orderdate?.toString() || "").includes(inputdata) ||
        (user.razorpayPaymentId?.toString() || "").includes(inputdata) ||
        (user.credits?.toString() || "").includes(inputdata) ||
        (user.finalPrice?.toString() || "").includes(inputdata) ||
        (user.postcade?.toString() || "").includes(inputdata) ||
        (user.state?.toString() || "").includes(inputdata) ||
        (user.razorpayPaymentId?.toString() || "").includes(inputdata) ||
        (user.credits?.toString() || "").includes(inputdata) ||
        (user.finalPrice?.toString() || "").includes(inputdata)
      );
    });
    setFilteredPayments(fdata);
  };

  //pagination
  const recordPerPage = 10;
  const lastIndex = currentPage * recordPerPage;
  const firstIndex = lastIndex - recordPerPage;
  const records = filtereddata.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filtereddata.length / recordPerPage);

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const nextPage = () => {
    if (currentPage < npage) setCurrentPage(currentPage + 1);
  };

  //filter by ticket name

  //refresh
  const handleRefresh = () => {
    setInputdata("");
    setFilteredPayments(filtereddata);
    setCurrentPage(1);
  };

  const handleRecipt = (id) => {
    const payment = filtereddata.find((p) => p._id === id);
    setSelectedReciept(payment);
    setRecieptPopup(true);
  };

  const closePopup = () => {
    setRecieptPopup(false);
  };

  const printRef = useRef(null);

  const handleDownloadPDF = async () => {
    if (!printRef.current) return;
    try {
      const style = document.createElement("style");
      style.innerHTML = ``;
      document.head.appendChild(style);
      // Generate canvas
      const canvas = await html2canvas(printRef.current, {
        scale: 4,
        useCORS: true,
        backgroundColor: "#ffffff",
        onclone: (documentClone) => {
          const clonedElement = documentClone.getElementById("printRefId");
          if (clonedElement) {
            clonedElement.style.fontFamily = "Arial, sans-serif";
            clonedElement.style.color = "black";
            clonedElement.style.border = "1px solid #000";
          }
        },
      });

      // Convert canvas to image
      const dataURL = canvas.toDataURL("image/png");

      // Create PDF
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Receipt.pdf");
      // Remove dynamically added styles after PDF generation
      document.head.removeChild(style);

      setRecieptPopup(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleExpendRow = (id) => {
    setExpendedRow((prev) => (prev === id ? null : id));
  };

  const reciptSubprice = selectedReciept?.usercart?.reduce(
    (acc, item) => acc + (Number(item.price * item.count) || 0),
    0
  );

  const firstTwoDigitGst = selectedReciept?.gst?.slice(0, 2);


  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                Hello AbsorbX 👋🏼
              </h1>
            </div>

            {recieptPopup && (
              <>
                <div
                  onClick={closePopup}
                  className="fixed inset-0 flex flex-col top-0 left-0 w-screen h-screen z-[9999] items-center justify-center bg-black bg-opacity-50"
                >
                  <button
                    className="bg-[#C65B1D] px-4 py-1 rounded-md text-white mb-2"
                    onClick={handleDownloadPDF}
                  >
                    Downolad PDF
                  </button>
                  <div
                    ref={printRef}
                    className="bg-white border flex flex-col gap-10  shadow-lg  w-[556px] h-[800px]  py-16 px-6 max-w-6xl"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        {/* <h2 className="text-sm font-semibold">
                          {selectedReciept.firstName} {selectedReciept.lastName}
                        </h2> */}
                        <p className="text-xs text-[#646464]">
                          Net zero Initicative Private Limited
                        </p>
                        <p className="text-xs text-[#646464]">
                          No. 45/3, Residency, Mfg Road, Bengaluru
                        </p>
                        <p className="text-xs text-[#646464]">
                          Bengaluru, Bengaluruurban, Karnataka, 560025
                        </p>
                        <p className="text-xs text-[#646464]">
                          GST: 29AAJCN6016B1ZM
                        </p>
                      </div>
                      <div>
                        <img className="w-[100px] h-[20px]" src={logo} alt="" />
                      </div>
                    </div>

                    <div className="text-xs">
                      <p className="text-[#505050]">
                        <span className="text-sm font-medium">
                          Payment Receipt :
                        </span>
                        Transaction Reference :{" "}
                        <span className="text-[#646464]">
                          {selectedReciept.razorpayPaymentId}
                        </span>{" "}
                      </p>
                      <p className="text-[#646464]">
                        This is a payment receipt for your transaction on
                        Project RenewCred-1
                      </p>
                    </div>

                    <div>
                      <h2 className="text-sm text-[#646464]">
                        AMOUNT PAID:{" "}
                        <span className="font-semibold text-sm">
                          ₹ {selectedReciept.finalPrice}
                        </span>
                      </h2>
                    </div>

                    <div className="grid grid-cols-2 text-[#646464] text-xs">
                      <div className="leading-5">
                        <p>ISSUED To</p>
                        <p>Email Id: {selectedReciept.emaiid}</p>
                        <p>Mo: {selectedReciept.phone}</p>
                        <p className="text-xs text-[#646464]">
                          GSTIN: <span>{selectedReciept.gst}</span>{" "}
                        </p>
                      </div>
                      <div>
                        <p>PAID ON</p>
                        <p>{selectedReciept.orderdate}</p>
                      </div>
                    </div>
                    <div className="">
                      <table className="min-w-[100%] table-auto  shadow-sm border border-separate border-spacing-0">
                        <thead className="bg-[#f0f0f0] h-1 font-medium">
                          <tr className="h-1">
                            <th className="py-1 h-1  text-[#646464] whitespace-nowrap   text-xs text-start border-b border-gray-300 ">
                              DESCRIPTION
                            </th>
                            <th className=" py-1 h-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs text-center border-b border-gray-300">
                              UNIT PRICE
                            </th>
                            <th className="py-1 h-1 w-[20px] text-[#646464] whitespace-nowrap   text-xs  text-center border-b border-gray-300">
                              QTY
                            </th>

                            <th className="py-1 h-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs  text-center border-b border-gray-300">
                              AMOUNT
                            </th>
                          </tr>
                        </thead>

                        <tbody className="text-[12px] font-normal">
                          {selectedReciept.usercart.map((user) => {
                            return (
                              <tr className="text-12px]">
                                <td className=" border text-[12px] text-[#646464] border-[#E4E7EC] text-start">
                                  {user.projectname}
                                </td>
                                <td className=" border text-[12px] text-[#646464] border-[#E4E7EC] text-center">
                                  {user.price}
                                </td>
                                <td className=" border text-[12px] text-[#646464] border-[#E4E7EC] text-center">
                                  {user.count}
                                </td>
                                <td className=" border text-[12px] text-[#646464] border-[#E4E7EC] text-center">
                                  {user.price * user.count}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="flex justify-end space-y-4 text-xs mb-10">
                        <div className="w-36 p-2 space-y-1">
                          <div className="flex justify-between items-center">
                            <p className="font-medium">Sub Total:</p>
                            <p className="font-normal">{reciptSubprice}</p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium">CGST:</p>
                            <p className="font-normal">
                              {firstTwoDigitGst === 29 ? 9 : 0}%
                            </p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium">SGST:</p>
                            <p className="font-normal">
                              {firstTwoDigitGst === 29 ? 9 : 0}%
                            </p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium">IGST:</p>
                            <p className="font-normal">
                              {firstTwoDigitGst === 29 ? 0 : 18}%
                            </p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium text-[#00AC4F]">
                              Amount Paid:
                            </p>
                            <p className="font-normal text-[#00AC4F]">₹ {reciptSubprice + reciptSubprice * 18 / 100} </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* section-3 */}
            <div className="border 2xl:mt-10 mt-7 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="mx-2 my-2 flex flex-wrap justify-between items-center">
                <div className="mb-3">
                  <h1 className="font-semibold 2xl:text-2xl text-xl">
                    All Orders
                  </h1>
                  {/* <h6 className="text-[#C65B1D] font-normal mt-1 max-2xl:text-sm">
                    Active Customers
                  </h6> */}
                </div>
                {/* filter table data form */}
                <div className="flex items-center flex-wrap gap-1">
                  <form
                    className="filterinput"
                    action=""
                    onSubmit={handleSubmit}
                  >
                    <input
                      onChange={handleChange}
                      type="text"
                      name="inputdata"
                      value={inputdata}
                      className="bg-[#F9FBFF]  sm:px-5 max-sm:w-[68%] pl-3 2xl:py-2 py-[0.40rem] border border-gray-300  outline-none focus:ring-2 focus:ring-[#C65B1D] rounded-lg text-xs max-md:my-1"
                      placeholder="Search"
                    />
                    <button
                      type="submit"
                      className="mr-1 ml-3 cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white py-[0.4rem] 2xl:text-sm text-xs rounded-lg 2xl:px-3 px-2"
                    >
                      Search
                    </button>
                  </form>
                  {/* filter table data by ticketname */}
                  <div className="flex justify-between items-center flex-wrap">
                    <i
                      onClick={handleRefresh}
                      className="fa-solid fa-arrows-rotate ml-2 cursor-pointer border border-gray-300 px-2 2xl:py-[0.45rem] py-[0.40rem] rounded-md bg-[#F9FBFF]"
                    ></i>
                  </div>
                </div>
              </div>

              {/* section-4 table */}
              <div className="mt-6 relative overflow-x-auto  overflow-y-hidden">
                <table className="w-full border-collapse border-spacing-0">
                  <thead>
                    <tr className="text-[#b5b7c0] m-12 font-medium">
                      <th>Sr no</th>
                      <th>Order ID</th>
                      <th>Date</th>
                      <th>Transaction ID</th>
                      <th>Credits (Tones)</th>
                      <th>Total Amount</th>
                      <th className="text-center">Receipt</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {lodding ? (
                      <tr>
                        <td colSpan="11" className="text-center">
                          <div className="flex justify-center items-center w-full h-full">
                            <SyncLoader
                              margin={1}
                              speedMultiplier={1}
                              color={"#069ea1"}
                              loading={lodding}
                              size={10}
                            />
                          </div>
                        </td>
                      </tr>
                    ) : (
                      (filteredPayments.length > 0
                        ? filteredPayments
                        : records
                      ).map((tdata, index) => {


                        const serialNumber = index + 1;

                        return (
                          <React.Fragment key={tdata.id}>
                            <tr
                              className="h-10 text-sm m-12 font-medium"
                              style={{ cursor: "pointer" }}
                            >
                              <td>{serialNumber}</td>
                              <td className="flex items-center gap-2">
                                <img src={ticket} alt="" />
                                {tdata.razorpayOrderId}
                              </td>
                              <td>{tdata.orderdate}</td>
                              {/* <td>₹ {(totalQut / 100).toFixed(2)}</td> */}
                              <td>{tdata.razorpayPaymentId}</td>
                              <td>{tdata.credits}</td>
                              <td>₹{tdata.finalPrice}</td>
                              {/* <td
                                className={`${
                                  filename
                                    ? "text-[#C65B1D] "
                                    : "text-[#969494]"
                                } whitespace-nowrap pl-4 py-2  text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300`}
                              >
                                {filename ? (
                                  <button
                                    onClick={() =>
                                      tdata.selectedFile &&
                                      window.open(tdata.selectedFile, "_blank")
                                    }
                                    className="text-[#C65B1D]"
                                  >
                                    download
                                  </button>
                                ) : (
                                  "download"
                                )}
                              </td> */}
                              {/* <td>
                                
                                  <button
                                    onClick={() =>
                                      tdata.selectedFile &&
                                      window.open(tdata.selectedFile, "_blank")
                                    }
                                    className="text-[#C65B1D]"
                                  >
                                    download
                                  </button>
                              
                              </td> */}

                              <td className="text-center">
                                <i
                                  onClick={() => handleRecipt(tdata._id)}
                                  className="fa-solid fa-download"
                                ></i>
                              </td>
                              <td>
                                <i
                                  onClick={() => handleExpendRow(index)}
                                  className={`fa-solid ${expendedRow === index
                                      ? "fa-minus"
                                      : "fa-plus"
                                    }  cursor-pointer`}
                                ></i>
                              </td>
                            </tr>
                            {expendedRow === index && (
                              <>
                                <tr>
                                  <td colSpan="12">
                                    <table className="min-w-[100%] my-2 table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                      <thead className="bg-[#FCFCFC] rounded-t-lg">
                                        <tr className="">
                                          <th
                                            className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8 border-[#E5E5E5]">
                                              Project ID
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Project Name
                                            </div>
                                          </th>
                                          {/* <th
                                            className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Vintage
                                            </div>
                                          </th> */}
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Credits (Tones)
                                            </div>
                                          </th>
                                          {/* <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Batch ID
                                            </div>
                                          </th> */}
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Unit Price
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="border-r pr-8  border-[#E5E5E5]">
                                              Amount
                                            </div>
                                          </th>
                                          <th
                                            className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                          >
                                            <div className="  border-[#E5E5E5]">
                                              Certificate
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {tdata.usercart.map((user, index) => (
                                          <tr key={index}>
                                            <td className="pl-4">
                                              {user.projectid}
                                            </td>
                                            <td className="pl-0">
                                              {user.projectname}
                                            </td>
                                            {/* <td>f</td> */}
                                            <td className="pl-0">
                                              {user.count}
                                            </td>
                                            {/* <td>f</td> */}
                                            <td className="pl-0">
                                              {user.price}
                                            </td>
                                            <td className="pl-0">
                                              {user.price * user.count}
                                            </td>
                                            <td className="pl-0"></td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </>
                            )}
                          </React.Fragment>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              {selectedPayment && (
                <PopUP
                  currentStatus={selectedPayment.status}
                  onClose={() => setSelectedPayment(null)}
                />
              )}
              {/* pagination */}
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg mr-2 transition duration-200 ease-in-out ${currentPage === 1
                      ? "opacity-50 cursor-not-allowed"
                      : "cursor-pointer"
                    }`}
                  aria-label="Previous Page"
                >
                  Prev
                </button>

                <button
                  onClick={nextPage}
                  disabled={currentPage === npage}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg ml-2 transition duration-200 ease-in-out ${currentPage === npage
                      ? "opacity-50 cursor-not-allowed"
                      : "cursor-pointer"
                    }`}
                  aria-label="Next Page"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyOrder;
